import { useRBACPermissions } from '@/contexts/useRBACPermissions'

export function useCanCreateAccount(): boolean {
  const { hasAdminRights, hasGtmRights, hasOperatorRights } =
    useRBACPermissions()
  return hasAdminRights() || hasGtmRights() || hasOperatorRights()
}
